import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

//Login Component
import Login from './components/Login';

import { BrowserRouter as Router, Route } from 'react-router-dom';

ReactDOM.render(<Router> 
    <div>
        <Route exact path="/" component={App} />
        <Route path="/login" component={Login} />
    </div>
</Router>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js